import {
  types,
  IModalOpenAction,
  IModalCloseAction,
  Modals,
} from '../types/modal'

export const modalOpen = (id: Modals, options = {}): IModalOpenAction => ({
  type: types.MODAL_OPEN,
  id,
  options,
})

export const modalClose = (): IModalCloseAction => ({
  type: types.MODAL_CLOSE,
})
